"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.NodePlaceholderFactory = exports.NodeFactory = void 0;
var utils_1 = require("../utils");
exports.NodeFactory = {
    createInstance: function (params) {
        var _a;
        var nodeDefUuid = params.nodeDefUuid, recordUuid = params.recordUuid, parentNode = params.parentNode, value = params.value;
        return {
            uuid: utils_1.UUIDs.v4(),
            nodeDefUuid: nodeDefUuid,
            recordUuid: recordUuid,
            parentUuid: parentNode === null || parentNode === void 0 ? void 0 : parentNode.uuid,
            value: value,
            meta: {
                h: __spreadArray(__spreadArray([], (((_a = parentNode === null || parentNode === void 0 ? void 0 : parentNode.meta) === null || _a === void 0 ? void 0 : _a.h) || []), true), ((parentNode === null || parentNode === void 0 ? void 0 : parentNode.uuid) ? [parentNode === null || parentNode === void 0 ? void 0 : parentNode.uuid] : []), true)
            }
        };
    }
};
exports.NodePlaceholderFactory = {
    createInstance: function (params) {
        return __assign(__assign({}, exports.NodeFactory.createInstance(params)), { placeholder: true });
    }
};
//# sourceMappingURL=factory.js.map